import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import * as moment from "moment"; // Needed For moment.preciseDiff() to work
import { PreciseDiff } from "../shared/precise-diff";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";

import { DataService_visitorselector } from "../visitorselector/shared/data.service";
import { VPPAdminVisitorSelectorSelectedVisitorInfo } from "../visitorselector/shared/VPPAdminVisitorSelectorSelectedVisitorInfo";

import { DataService_viewvisitor } from "./shared/data.service";
import { DataService_viewvisitordetail } from "../viewvisitordetail/shared/data.service";

import { wsFacilityByUserIDListInfo } from "./shared/wsFacilityByUserIDListInfo";
import { wsVPPAdminVisitorListParm } from "./shared/wsVPPAdminVisitorListParm";
import { wsVPPAdminVisitorListInfo } from "./shared/wsVPPAdminVisitorListInfo";

import { PrintVisitorComponent } from "./printvisitor/printvisitor.component";
import { EditVisitorComponent } from "./editvisitor/editvisitor.component";
import { VerifyVisitorComponent } from "./verifyvisitor/verifyvisitor.component";
import { ImportBlockComponent } from "./importblock/importblock.component";

import { ViewChild } from "@angular/core";
import { ReportFileTypeDialogComponent } from "../../student/shared/report-file-type-dialog/report-file-type-dialog.component";
import { ReportService } from "../../Report/report.service";
import { wsVPPAdminVisitorTransferInfo } from "./shared/wsVPPAdminVisitorTransferInfo";

//
// Needed For moment.preciseDiff() to work
//
// declare module "moment" {
// 	function preciseDiff(start: string | Date | moment.Moment, end: string | Date | moment.Moment, convertToObject?: boolean): any;
// }

@Component({
	selector: "app-root",
	templateUrl: "./viewvisitor.component.html",
	styleUrls: ["./viewvisitor.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class ViewVisitorComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterVisitorLogStatusDesc", { static: false })
	public filterVisitorLogStatusDesc: Dropdown;
	@ViewChild("filterEntryFacilityLocation", { static: false })
	public filterEntryFacilityLocation: Dropdown;
	@ViewChild("filterDestinationFacilityLocation", { static: false })
	public filterDestinationFacilityLocation: Dropdown;
	@ViewChild("filterScanStation", { static: false })
	public filterScanStation: Dropdown;
	@ViewChild("filterFacilityName", { static: false })
	public filterFacilityName: Dropdown;

	VisitorSelectorPersonIDSubscription: Subscription;

	constructor(
		private VisitorSelectorService: DataService_visitorselector,
		private dataService: DataService_viewvisitor,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		private ViewVisitorDetail: DataService_viewvisitordetail,
		private reportService: ReportService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public ErrorMessage: string = "";

	//	Visitor Selector
	public SelectedVisitor: VPPAdminVisitorSelectorSelectedVisitorInfo = {
		FacilityID: -1,
		Visitor_PersonID: -1,
	};

	//	DateRange Selector
	public lstDateRange: any = [];
	public SelectedDateRange: any;

	//	Visitor Log List
	public lstVisitorLog: wsVPPAdminVisitorListInfo[] = [];
	public SelectedVisitorLog: wsVPPAdminVisitorListInfo;

	//	Filters
	public lstVisitorLogStatusDescs: any = [];
	public lstEntryFacilityLocations: any = [];
	public lstDestinationFacilityLocations: any = [];
	public lstFacilityNames: any = [];
	public lstScanStations: any = [];

	//	Visitor Log Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	public StartDate: Date = new Date();
	public EndDate: Date = new Date();

	public isProcessing: boolean = false;
	public errorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.ErrorMessage = "";
		this.user = this.userService.getCurrentUser();

		//
		//	Visitor Selector - Person Selected
		//
		this.VisitorSelectorPersonIDSubscription = this.VisitorSelectorService.onVisitorSelected().subscribe((response) => {
			this.SelectedVisitor = response;
			this.onRefresh();
		});

		//
		//	Set DateRange Selector
		//
		this.lstDateRange = [
			{ DateRangeID: 1, DateRangeDesc: "Today", LastXMonths: 0 },
			{ DateRangeID: 2, DateRangeDesc: "Last Month", LastXMonths: 1 },
			{ DateRangeID: 3, DateRangeDesc: "Last 2 Months", LastXMonths: 2 },
			{ DateRangeID: 4, DateRangeDesc: "Last 3 Months", LastXMonths: 3 },
			{
				DateRangeID: 5,
				DateRangeDesc: "Custom Date Range",
				LastXMonths: -1,
			},
		];

		this.SelectedDateRange = this.lstDateRange[0];
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.VisitorSelectorPersonIDSubscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterVisitorLogStatusDesc.clear(null);
		this.filterFacilityName.clear(null);
		this.filterScanStation.clear(null);
		this.filterDestinationFacilityLocation.clear(null);
		this.filterEntryFacilityLocation.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		let StartDateParm = new Date();
		StartDateParm.setHours(0, 0, 0, 0); // Clear Hours

		let EndDateParm = new Date();
		EndDateParm.setHours(0, 0, 0, 0); // Clear Hours

		this.ErrorMessage = "";

		if (this.SelectedDateRange.DateRangeID == 5) {
			// Custom Date Range
			if (this.StartDate == null) {
				this.ErrorMessage = "Invalid Start Date";
				return;
			} else {
				StartDateParm = this.StartDate;
				StartDateParm.setHours(0, 0, 0, 0); // Clear Hours
			}

			if (this.EndDate == null) {
				this.ErrorMessage = "Invalid End Date";
				return;
			} else {
				EndDateParm = this.EndDate;
				EndDateParm.setHours(0, 0, 0, 0); // Clear Hours
			}

			if (this.StartDate > this.EndDate) {
				this.ErrorMessage = "Start Date cannot be greater than End Date";
				return;
			}

			//
			//	Greater Than 1 Year Check when ALL facilities are selected
			//
			if (this.SelectedVisitor.FacilityID == -1 && this.EndDate > this.StartDate) {
				let DayDiff = PreciseDiff.preciseDiff(this.StartDate, this.EndDate, true);

				if (DayDiff.years > 10 || (DayDiff.years == 1 && (DayDiff.months > 0 || DayDiff.days > 0))) {
					this.ErrorMessage = "Date range must be less then 10 years when ALL facilities are selected.";
					return;
				}
			}
		}

		let parms: wsVPPAdminVisitorListParm = {
			UserID: this.user.userID,
			FacilityID: this.SelectedVisitor.FacilityID,
			Visitor_PersonID: this.SelectedVisitor.Visitor_PersonID,
			LastXMonths: this.SelectedDateRange.LastXMonths,
			StartDate: StartDateParm,
			EndDate: EndDateParm,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorSelectList(parms).subscribe((data) => this.VPPAdminVisitorSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorSelectList_Complete(data: any) {
		this.SelectedVisitorLog = null;
		this.lstVisitorLog = data;

		//
		//	Clear Detail Data
		//
		this.ViewVisitorDetail.VisitorLogSelected(-1);

		//
		//	Set Filter Lists
		//
		this.lstVisitorLogStatusDescs = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.VisitorLogStatusDesc)));
		this.lstEntryFacilityLocations = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.EntryFacilityLocation)));
		this.lstDestinationFacilityLocations = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.DestinationFacilityLocation)));
		this.lstFacilityNames = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.FacilityName)));
		this.lstScanStations = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.ScanStation)));

		//
		//	Reset Filters
		//
		this.onClearFilters();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "logDT", order: 1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		//
		//	Display Print Popup
		//
		var ref = this.dialogService.open(PrintVisitorComponent, {
			header: "Print",
			width: "435px",
			data: {
				Visitor_PersonID: this.SelectedVisitor.Visitor_PersonID,
				UserPersonID: this.user.personID,
				UserID: this.user.userID,
				FacilityID: this.SelectedVisitor.FacilityID,
				DateRangeID: this.SelectedDateRange.DateRangeID,
				StartDate: this.StartDate,
				EndDate: this.EndDate,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddBlockedVisitor
	//
	//-----------------------------------------------------------------------------------------------------
	onAddBlockedVisitor() {
		//
		//	Display Add Blocked Popup
		//
		var ref = this.dialogService.open(EditVisitorComponent, {
			header: "Add Blocked Visitor",
			width: "880px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
				Visitor_PersonID: -1,
				isAllowStatusChange: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.VisitorSelectorService.SearchRefresh("Refresh");
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEditVisitor
	//
	//-----------------------------------------------------------------------------------------------------
	onEditVisitor() {
		//
		//	Validate
		//
		if (this.SelectedVisitor.Visitor_PersonID == null || this.SelectedVisitor.Visitor_PersonID < 0) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a visitor.",
				header: "Edit Visitor",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		//
		//	Display Edit Popup
		//
		var ref = this.dialogService.open(EditVisitorComponent, {
			header: "Edit Visitor",
			width: "880px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
				Visitor_PersonID: this.SelectedVisitor.Visitor_PersonID,
				isAllowStatusChange: true,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.VisitorSelectorService.SearchRefresh("Refresh");
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onValidateVisitor
	//
	//-----------------------------------------------------------------------------------------------------
	onValidateVisitor() {
		//
		//	Validate
		//
		if (this.SelectedVisitor.Visitor_PersonID == null || this.SelectedVisitor.Visitor_PersonID < 0) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a visitor.",
				header: "Edit Visitor",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		//
		//	Display Verify Popup
		//
		var ref = this.dialogService.open(VerifyVisitorComponent, {
			header: "Validate Visitor",
			width: "880px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
				Visitor_PersonID: this.SelectedVisitor.Visitor_PersonID,
				isAllowStatusChange: true,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.VisitorSelectorService.SearchRefresh("Refresh");
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onImportBlockList
	//
	//-----------------------------------------------------------------------------------------------------
	onImportBlockList() {
		//
		//	Display Import Popup
		//
		var ref = this.dialogService.open(ImportBlockComponent, {
			header: "Import Block List",
			width: "900px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.VisitorSelectorService.SearchRefresh("Refresh");
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExportBlockList
	//
	//-----------------------------------------------------------------------------------------------------
	onExportBlockList() {
		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		this.errorMessage = "";
		this.isProcessing = true;

		var strParam = "";

		//Parameter 1: SchoolID
		strParam += -1 + "|SchoolID";

		//Parameter 2: FacilityID
		strParam += "," + -1 + "|FacilityID";

		//Parameter 3: VisitorTypeID
		strParam += "," + -1 + "|VisitorTypeID";

		//Parameter 4: UserID
		strParam += "," + this.user.userID + "|UserID";

		//Parameter 5: ORDERBY
		strParam += "," + "FirstName" + "|ORDERBY";

		//Parameter 6: ImageLogo
		strParam += "," + "8C87B20B-5813-4F74-8375-9898FD7B0C74" + "|Imagelogo";

		var reportID: any = 444;

		//Add type selector
		var result = this.reportService.Print(reportID, strParam, -1, OutputType);

		result.subscribe(
			(response: any) => {
				this.isProcessing = false;
				window.open(response);
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}

	onTransferVisitors() {
		this.isProcessing = true;

		var result = this.dataService.VPPAdminVisitorTransferToVPP3();
		result.subscribe(
			(response: wsVPPAdminVisitorTransferInfo) => {
				this.isProcessing = false;

				if (response.Success == true) {
					var Msg: string = "";

					if (response.TransferCount == 0) {
						Msg = "All visitors have already been transferred to the new VPP";
					} else {
						Msg = response.TransferCount + " visitors were transfered successfully.";
					}

					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: Msg,
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not transfer visitors: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {
		this.ViewVisitorDetail.VisitorLogSelected(this.SelectedVisitorLog.VisitorLogID);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedFacilityLocation here. We don't unselect when selected.
		//
		this.SelectedVisitorLog = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDateRangeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onDateRangeChange(value) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDateChange(val) {
		this.StartDate = val;
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDateChange(val) {
		this.EndDate = val;
		this.onRefresh();
	}
	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
